<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('Integrations') }}</h4>
      </template>
    </iq-card>
    <b-row>

      <!-- Dijital İzin -->
      <b-col xl="4" md="6" sm="12" class="mb-4">
        <iq-card class="h-100">
          <template v-slot:body>
            <div class="integration-tag">
              <span class="badge badge-pill" style="background:#17a2b8; color:#fff;">#data</span>
            </div>
            <div class="text-center pt-2">
              <img src="https://s3.stellamedi.com/stellamedi-cdn/images/partners/digital-signature-logo.png"
                   alt="Digital Consent" class="integration-img" />
              <h5 class="font-weight-bold mt-3 mb-1">{{ $t('DigitalSignatureName') }}</h5>
              <p class="text-muted integration-desc">
                {{ $t('DigitalSignatureDescription') }}
              </p>
              <div class="credit-display" v-if="digitalSignatureCredit !== null">
                <span>{{ $t('Credit') }}:</span>
                <strong class="credit-value">&nbsp;{{ digitalSignatureCredit }}</strong>
              </div>
              <div v-else class="text-muted small mt-2">
                {{ $t('NotActivated') }}
              </div>
            </div>
          </template>
        </iq-card>
      </b-col>

    </b-row>
  </b-container>
</template>

<script>
  import axios from '../../../services/index'

  export default {
    name: 'IntegrationList',
    data() {
      return {
        digitalSignatureCredit: null
      }
    },
    methods: {
      getDigitalSignatureBalance() {
        axios.get('/api/digitalSignature/GetAccountBalance')
          .then(response => {
            this.digitalSignatureCredit = response.data;
          }).catch(() => {
            this.digitalSignatureCredit = null;
          });
      }
    },
    mounted() {
      this.getDigitalSignatureBalance();
    }
  }
</script>

<style scoped>
  .integration-tag {
    margin-bottom: 8px;
  }
  .integration-img {
    width: 80px;
    height: 80px;
    object-fit: contain;
  }
  .integration-desc {
    font-size: 0.875rem;
    line-height: 1.5;
    min-height: 60px;
    padding: 0 10px;
  }
  .credit-display {
    font-size: 0.9rem;
    font-weight: 600;
    margin-top: 8px;
    padding-bottom: 4px;
  }
  .credit-value {
    color: #20c997;
    font-weight: 700;
  }
</style>
